var _defs, _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.39 247.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#1b0400;stroke-miterlimit:10;}.cls-1,.cls-7{stroke-width:15px;}.cls-1{fill:url(#linear-gradient);}.cls-2,.cls-3{stroke-width:10px;}.cls-2{fill:url(#linear-gradient-2);}.cls-3,.cls-6{fill:none;}.cls-3,.cls-4,.cls-6{stroke-linecap:round;}.cls-4{fill:#f3ff4b;}.cls-4,.cls-5{stroke-width:5px;}.cls-5{fill:#ff8138;}.cls-6{stroke-width:7px;}.cls-7{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 260.45,
    y1: 244.29,
    x2: 55.55,
    y2: 39.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbc000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 233.94,
    y1: 341.82,
    x2: 67.72,
    y2: 175.6,
    gradientTransform: "matrix(-0.78, 0.85, -0.84, -0.76, 481.62, 200.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0012db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff367f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 209.4,
    y1: 286.1,
    x2: 86.6,
    y2: 73.41,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.55,
    y: 43.34,
    width: 226.9,
    height: 197,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.1,248.24,18.25,157.41c-6.39-5.81-6.62-16.1-.52-22.8L120.88,21.22c6.1-6.71,16.37-7.45,22.75-1.64l134.12,122c6.39,5.81,6.62,16.1.52,22.8L207,242.77a6.47,6.47,0,0,1-3.89,2c-17.87,1.55-52.86,3.3-80.83,4.89A5.5,5.5,0,0,1,118.1,248.24Z",
    transform: "translate(-8.3 -10.66)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.92,
    y1: 118.51,
    x2: 87.98,
    y2: 185.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 166.84,
    y1: 134.82,
    x2: 105.47,
    y2: 201.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.98,
    y1: 150.41,
    x2: 166.59,
    y2: 169.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.47,
    y1: 166.31,
    x2: 184.08,
    y2: 185.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.59,155.63l-2.09,2.29C228,164,218.74,164.66,213,159.41l-2.18-2c-5.77-5.25-6-14.51-.46-20.57l2.09-2.3c5.51-6.07,14.75-6.73,20.52-1.48l2.18,2C241,140.39,241.19,149.47,235.59,155.63Z",
    transform: "translate(-8.3 -10.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.89,104.23l4.18,14.55a2.32,2.32,0,0,1-1.48,2.86,2.66,2.66,0,0,1-1.19.08l-14.89-3-14.88-3a2.08,2.08,0,0,1-1.6-2.63,1.81,1.81,0,0,1,.58-1l10.61-11.67,10.62-11.67A2.2,2.2,0,0,1,191,88.7a3.43,3.43,0,0,1,.62.9Z",
    transform: "translate(-8.3 -10.66)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 163.78,
    y1: 67.04,
    x2: 117.14,
    y2: 118.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 146.29,
    y1: 51.13,
    x2: 99.65,
    y2: 102.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 128.72,
    y1: 35.15,
    x2: 82.08,
    y2: 86.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.07,
    y1: 103.53,
    x2: 75.48,
    y2: 112.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.77,
    y1: 121.44,
    x2: 69.58,
    y2: 140.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.43,
    y1: 137.69,
    x2: 70.5,
    y2: 169.59
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.28,250H268.64c5.48,0,9.17-3,8.21-6.69L243.45,116.2c-1-3.68-6.24-6.69-11.73-6.69H27.36c-5.48,0-9.17,3-8.21,6.69l33.4,127.11C53.52,247,58.79,250,64.28,250Z",
    transform: "translate(-8.3 -10.66)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.650ba314d33887fccc1668f8328da988.svg";
export { ForwardRef as ReactComponent };